<template>
  <div class="main-box">
    <div class="div-box left">
      <div class="top" v-if="showSearch">
        <span class="info">未添加到该直播的学生（{{leftTotal}}个学生）</span>
        <div class="search-box">
           <input class="input-box" type="text" v-model="searchVal" @input="leftInputChange" />
           <img v-if="searchVal === ''" class="search-icon" src="../../assets/component/adduser/search_icon.png"/>
           <img v-else class="search-icon" src="../../assets/component/adduser/delete_icon.png" @click="cleanLeftClick" />
        </div>
      </div>
      <div class="userlist">
        <div class="item" v-for="(item, index) in leftList" :key="index">
          <div class="name">{{item.Name}}</div>
          <span class="code">+86</span>
          <span class="phone">{{item.Mobile}}</span>
          <img src="../../assets/component/adduser/plus_icon.png" class="operator" @click="addClick(item)"/>
        </div>
      </div>
      <el-pagination
         v-if="leftTotal"
         small
         layout="prev, pager, next"
         :total="leftTotal"
         :pager-count="7"
         :page-size="pageSize"
         @current-change="leftPageChange">
      </el-pagination>
    </div>
    <div class="div-box right">
      <div class="top" v-if="showSearch">
        <span class="info">已选择学生({{rightTotal}}个学生)</span>
        <div class="search-box">
           <input class="input-box" type="text" v-model="searchRightVal"  @input="rightInputChange"/>
           <img v-if="searchRightVal === ''" class="search-icon" src="../../assets/component/adduser/search_icon.png" @click="cleanRightClick" />
            <img v-else class="search-icon" src="../../assets/component/adduser/delete_icon.png" @click="cleanRightClick" />
        </div>
      </div>
      <div class="userlist">
        <div class="item" v-for="(item, index) in rightList" :key="index">
          <div class="name">{{item.Name}}</div>
          <span class="code">+86</span>
          <span class="phone">{{item.Mobile}}</span>
          <img src="../../assets/component/adduser/delete_icon.png" class="operator" @click="removeClick(item)"/>
        </div>
      </div>
      <el-pagination
         small
         v-if="rightTotal"
         layout="prev, pager, next"
         @current-change="rightPageChange"
         :pager-count="7"
         :page-size="pageSize"
         :total="rightTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectUserComponent',
  props: {
    pageSize: {
      type: Number,
      default: 5
    },
    showSearch: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    leftPageChange: function (data) {
      this.leftCurPage = data
      this.$emit('unSelectPageChange', this.pageSize, data)
    },
    rightPageChange: function (data) {
      this.rightCurPage = data
      this.$emit('selectPageChange', this.pageSize, data)
    },
    cleanLeftClick: function () {
      if (this.searchVal === '') return
      this.searchVal = ''
      this.leftInputChange()
    },
    cleanRightClick: function () {
      if (this.searchRightVal === '') return
      this.searchRightVal = ''
      this.rightInputChange()
    },
    leftInputChange: function () {
      if (this.leftOldVal === '' && this.searchVal === '') return
      if (this.leftOldVal === this.searchVal) return
      this.leftOldVal = this.searchVal
      this.$emit('searchUnSelectClick', this.searchVal)
    },
    rightInputChange: function () {
      if (this.rightOldVal === '' && this.searchRightVal === '') return
      if (this.rightOldVal === this.searchRightVal) return
      this.rightOldVal = this.searchRightVal
      this.$emit('searchSelectClick', this.searchRightVal)
    },
    selectedSuccess: function (item) {
      // 头部添加
      this.rightList.unshift(item)
      this.delItem(this.leftList, item)
      this.leftTotal--
      this.rightTotal++
      // 判断是是否超过最大个数，如果超过，尾部移除
      if (this.rightList.length > this.pageSize) {
        this.rightList.pop()
      }
      // 判断未添加的page
      console.log(this.leftCurPage + ' - ' + this.leftTotal + ' - ' + (this.leftTotal / this.pageSize) )
      if (this.leftCurPage >= Math.ceil(this.leftTotal / this.pageSize)) {
        this.leftCurPage = Math.ceil(this.leftTotal / this.pageSize)
      }
    },
    addClick: function (item) {
      this.$emit('selected', item)
    },
    unSelectedSuccess: function (item) {
      this.leftList.unshift(item)
      this.delItem(this.rightList, item)
      this.leftTotal++
      this.rightTotal--
      // 判断是是否超过最大个数，如果超过，尾部移除
      if (this.leftList.length > this.pageSize) {
        this.leftList.pop()
      }

      // 判断未添加的page
      if (this.rightCurPage >= Math.ceil(this.rightTotal / this.pageSize)) {
        this.rightCurPage = Math.ceil(this.rightTotal / this.pageSize)
      }
    },
    removeClick: function (item) {
      this.$emit('unSelected', item)
    },
    delItem: function (list, item) {
      for (let i = 0; i < list.length; i++) {
        let _item = list[i]
        if (_item.Id === item.Id) {
          list.splice(i, 1)
          break
        }
      }
    },
    setUnSelectList: function (list, total) {
      if (!list) {
        this.leftList = []
        this.leftTotal = 0
      } else {
        this.leftList = list.concat()
        this.leftTotal = total
      }
    },
    setSelectList: function (list, total) {
      if (!list) {
        this.rightList = []
        this.rightTotal = 0
      } else {
        this.rightList = list.concat()
        this.rightTotal = total
      }
    },
    getUnSelectCurPage: function () {
      return this.leftCurPage
    },
    getSelectCurPage: function () {
      return this.rightCurPage
    },
    release: function () {
      this.leftOldVal = ''
      this.rightOldVal = ''
      this.searchLeftList = []
      this.searchRightList = []
      this.searchVal = ''
      this.searchRightVal = ''
      this.leftTotal = 0
      this.rightTotal = 0
      this.leftCurPage = 1
      this.rightCurPage = 1
    }
  },
  data () {
    return {
      searchLeftList: [],
      searchRightList: [],
      leftList: [],
      rightList: [],
      searchVal: '',
      searchRightVal: '',
      leftTotal: 0,
      rightTotal: 0,
      pagerCount: 4,
      leftCurPage: 1,
      rightCurPage: 1,
      leftOldVal: '',
      rightOldVal: ''
    }
  }
}
</script>

<style scoped>

  .top{
    padding: 5px 10px;
    background: #fff;
  }

  .top .info{
    font-size: 6px;
    color: #c1c1c1;
  }
  .main-box {
    display: flex;
    flex-direction: row;
    background-color: #fff;
    height: 400px;
  }
  .div-box{
    border: 1px solid #cccccc;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .left{
    height: 100%;
    flex: 1;
  }
  .right{
    height: 100%;
    flex: 1;
  }
  .name{
    color: #000;
    font-size: 16px;
    font-family: 'Microsoft YaHei';
  }
  .code {
    color: #c1c1c1;
    font-size: 12px;
  }

  .phone {
    color: #c1c1c1;
    font-size: 12px;
  }

  .item{
    position: relative;
    display: inline-block;
    margin: 5px 10px;
  }

  .operator{
    position: absolute;
    right: 0px;
    width: 20px;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
  }

  .userlist{
    display: flex;
    flex-direction: column;
    overflow-y : scroll;
    margin-top: 10px;
    margin-bottom: 10px;
    flex: 1;
  }
  .search-box{
    display: flex;
    flex-direction: row;
    margin-top: 5px;
  }

  .input-box{
    flex: 1;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .search-icon{
    padding: 8px;
    width: 15px;
    height: 15px;
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/selectuser/SelectUserComponent.vue